module.exports = __webpack_public_path__ + "static/media/gulp1.99a69c66.mp3";